import { render, staticRenderFns } from "./CreateCustomerSampleOrderPopUp.vue?vue&type=template&id=38097e05&scoped=true&"
import script from "./CreateCustomerSampleOrderPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerSampleOrderPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerSampleOrderPopUp.vue?vue&type=style&index=0&id=38097e05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38097e05",
  null
  
)

export default component.exports